import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

const CANCEL_QUEUED_PRODUCT_CHANGE = gql`
	mutation cancelQueuedProductChange ($id: ID!) {
		cancelQueuedProductChange(id: $id) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

export default CANCEL_QUEUED_PRODUCT_CHANGE;

